@if (profileActionState === profileActionStateEnum.default) {
  <div *ngVar="profile$ | async as profile" class="profile-grid">
    <span>
      <app-label class="max-w-56 overflow-hidden truncate" [name]="profile.name"></app-label>
      <svg-icon class="ml-2" [src]="'info-grey'" [ngbTooltip]="profile.description" [placement]="'top'"></svg-icon>
    </span>
    <span *ngVar="companiesCounts$ | async as companiesCounts" class="text-navy-90 text-lg">
      {{ companiesCounts | i18nPlural: companiesMapping | translate: { count: companiesCounts } }}
    </span>
    <span>
      @if ((isDefaultProfile$ | async) === false) {
        <app-three-dots-menu hree-dots-menu [menuActions]="menuActions"></app-three-dots-menu>
      }
    </span>
  </div>
} @else {
  <div class="flex items-center justify-between bg-navy-20 rounded-md p-1 w-full">
    <span
      class="flex items-center gap-2"
      [ngbTooltip]="
        buildTranslationKey(
          profileActionState === profileActionStateEnum.edit ? 'profileEditTooltip' : 'profileDeleteTooltip'
        ) | translate
      "
      [placement]="'top'"
    >
      <svg-icon [src]="'status_not_started'"></svg-icon>
      <span class="text-pink-50 text-base underline">{{ buildTranslationKey('profileInUse') | translate }}</span>
    </span>

    <span class="flex items-center gap-1">
      <app-new-button [type]="'basic'" [size]="'responsive'" [verticalSize]="'small'" (click)="resetProfileState()">
        {{ buildTranslationKey('cancel') | translate }}
      </app-new-button>

      <app-new-button
        [type]="'secondary'"
        [size]="'responsive'"
        [verticalSize]="'small'"
        (click)="
          profileActionState === profileActionStateEnum.edit ? openAddEditProfileModal(profileId) : deleteProfile()
        "
      >
        {{ buildTranslationKey(profileActionState) | translate }}
      </app-new-button>
    </span>
  </div>
}
